import { render, staticRenderFns } from "./PayEvent.vue?vue&type=template&id=2799e288&"
import script from "./PayEvent.vue?vue&type=script&lang=js&"
export * from "./PayEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports